import { render } from "./ArchivalMeasurements.vue?vue&type=template&id=71ac1a05&scoped=true"
import script from "./ArchivalMeasurements.vue?vue&type=script&lang=js"
export * from "./ArchivalMeasurements.vue?vue&type=script&lang=js"

import "./ArchivalMeasurements.vue?vue&type=style&index=0&id=71ac1a05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ac1a05"]])

export default __exports__